import React, { FC } from 'react'
import { Box, Typography } from 'transfix-ui/core'
import { ResponsiveLayout } from 'apps/fleet-planner/components/layout/ResponsiveLayout'
import { ResponsiveLayoutRow } from 'apps/fleet-planner/components/layout/ResponsiveLayoutRow'
import { ELDIntegrationsListMobile } from 'apps/fleet-planner/components/user/ELDIntegrationsListMobile'
import { useMembershipContext } from 'apps/fleet-planner/context/MembershipContext'
import { useELDIntegration } from 'apps/fleet-planner/hooks'
import { IMotorCarrier } from 'apps/fleet-planner/types'

interface IELDIntegrationsPageProps {
  /**
   * A function provided by the parent component to navigate to the default page
   */
  onGoToDefaultRoute: () => void
}

export const ELDIntegrationsPage: FC<IELDIntegrationsPageProps> = ({ onGoToDefaultRoute }) => {
  const { userMotorCarriers = [], isUserMotorCarriersLoading } = useMembershipContext()
  const { createRouteClickHandler } = useELDIntegration()

  const pressBackButtonHandler = () => {
    onGoToDefaultRoute()
  }

  const itemClickHandler = ({ id: carrierId }: IMotorCarrier) => {
    createRouteClickHandler(carrierId)
  }

  return (
    <ResponsiveLayout title='ELD Integrations' onPressBackButton={pressBackButtonHandler}>
      <ResponsiveLayoutRow>
        <Typography variant='body1'>
          When you bring your ELD-connected trucks into Transfix, you’ll be able see your truck’s
          current location and get live tracking updates for loads.
        </Typography>

        <Box pt={2}>
          <ELDIntegrationsListMobile
            motorCarriers={userMotorCarriers}
            loading={isUserMotorCarriersLoading}
            onItemClick={itemClickHandler}
          />
        </Box>
      </ResponsiveLayoutRow>
    </ResponsiveLayout>
  )
}
